import script from "./AdminPricing.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPricing.vue?vue&type=script&setup=true&lang=ts"

import "./AdminPricing.vue?vue&type=style&index=0&id=b1c1f1e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c1f1e2"]])

export default __exports__